// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Color} from './color.js'
import {Id} from './id.js'
import {InkStyle} from './ink-style.js'
import {Point} from './point.js'
import {SeqId} from './seq-id.js'
import {SetColor} from './set-color.js'
import {SetFloat} from './set-float.js'
import {SetSize} from './set-size.js'
import {StyleMap} from './style-map.js'
import {TapePattern} from './tape-pattern.js'

export class ModifyInk {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyInk {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyInk(bb: flatbuffers.ByteBuffer, obj?: ModifyInk): ModifyInk {
    return (obj || new ModifyInk()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyInk(bb: flatbuffers.ByteBuffer, obj?: ModifyInk): ModifyInk {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyInk()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  inks(index: number, obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 8, this.bb!) : null
  }

  inksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  page(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  origin(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  rotation(obj?: SetFloat): SetFloat | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new SetFloat()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  scale(obj?: SetSize): SetSize | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? (obj || new SetSize()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  style(): InkStyle | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  color(obj?: Color): Color | null {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? (obj || new Color()).__init(this.bb_pos + offset, this.bb!) : null
  }

  width(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  encodedCenterPath(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0
  }

  encodedCenterPathLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  encodedCenterPathArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset)
        )
      : null
  }

  encodedCustomPath(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0
  }

  encodedCustomPathLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  encodedCustomPathArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset)
        )
      : null
  }

  encodedFillPath(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0
  }

  encodedFillPathLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  encodedFillPathArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset)
        )
      : null
  }

  fillColor(obj?: SetColor): SetColor | null {
    const offset = this.bb!.__offset(this.bb_pos, 26)
    return offset ? (obj || new SetColor()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  styleMap(index: number, obj?: StyleMap): StyleMap | null {
    const offset = this.bb!.__offset(this.bb_pos, 28)
    return offset
      ? (obj || new StyleMap()).__init(this.bb!.__vector(this.bb_pos + offset) + index * 20, this.bb!)
      : null
  }

  styleMapLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 30)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  nibAngle(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 32)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : null
  }

  nibFlatness(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 34)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : null
  }

  tapePattern(): TapePattern | null {
    const offset = this.bb!.__offset(this.bb_pos, 36)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  inkEffects(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 38)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  inkEffectsTinted(): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 40)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startModifyInk(builder: flatbuffers.Builder) {
    builder.startObject(19)
  }

  static addInks(builder: flatbuffers.Builder, inksOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, inksOffset, 0)
  }

  static startInksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(8, numElems, 4)
  }

  static addPage(builder: flatbuffers.Builder, pageOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, pageOffset, 0)
  }

  static addOrigin(builder: flatbuffers.Builder, originOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, originOffset, 0)
  }

  static addRotation(builder: flatbuffers.Builder, rotationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, rotationOffset, 0)
  }

  static addScale(builder: flatbuffers.Builder, scaleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, scaleOffset, 0)
  }

  static addStyle(builder: flatbuffers.Builder, style: InkStyle) {
    builder.addFieldInt8(5, style, null)
  }

  static addColor(builder: flatbuffers.Builder, colorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(6, colorOffset, 0)
  }

  static addWidth(builder: flatbuffers.Builder, width: number) {
    builder.addFieldFloat32(7, width, null)
  }

  static addEncodedCenterPath(builder: flatbuffers.Builder, encodedCenterPathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, encodedCenterPathOffset, 0)
  }

  static createEncodedCenterPathVector(builder: flatbuffers.Builder, data: number[] | Uint8Array): flatbuffers.Offset {
    builder.startVector(1, data.length, 1)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!)
    }
    return builder.endVector()
  }

  static startEncodedCenterPathVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1)
  }

  static addEncodedCustomPath(builder: flatbuffers.Builder, encodedCustomPathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, encodedCustomPathOffset, 0)
  }

  static createEncodedCustomPathVector(builder: flatbuffers.Builder, data: number[] | Uint8Array): flatbuffers.Offset {
    builder.startVector(1, data.length, 1)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!)
    }
    return builder.endVector()
  }

  static startEncodedCustomPathVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1)
  }

  static addEncodedFillPath(builder: flatbuffers.Builder, encodedFillPathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, encodedFillPathOffset, 0)
  }

  static createEncodedFillPathVector(builder: flatbuffers.Builder, data: number[] | Uint8Array): flatbuffers.Offset {
    builder.startVector(1, data.length, 1)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!)
    }
    return builder.endVector()
  }

  static startEncodedFillPathVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1)
  }

  static addFillColor(builder: flatbuffers.Builder, fillColorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, fillColorOffset, 0)
  }

  static addStyleMap(builder: flatbuffers.Builder, styleMapOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, styleMapOffset, 0)
  }

  static startStyleMapVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(20, numElems, 4)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(13, zIndex, null)
  }

  static addNibAngle(builder: flatbuffers.Builder, nibAngle: number) {
    builder.addFieldInt16(14, nibAngle, null)
  }

  static addNibFlatness(builder: flatbuffers.Builder, nibFlatness: number) {
    builder.addFieldInt16(15, nibFlatness, null)
  }

  static addTapePattern(builder: flatbuffers.Builder, tapePattern: TapePattern) {
    builder.addFieldInt8(16, tapePattern, null)
  }

  static addInkEffects(builder: flatbuffers.Builder, inkEffects: bigint) {
    builder.addFieldInt64(17, inkEffects, null)
  }

  static addInkEffectsTinted(builder: flatbuffers.Builder, inkEffectsTinted: boolean) {
    builder.addFieldInt8(18, +inkEffectsTinted, null)
  }

  static endModifyInk(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // inks
    return offset
  }
}
